module.exports = __webpack_public_path__ + "static/Icons_SecondHome_large-219695742760bae4c118ddfba779b9f8.png";